import { render, staticRenderFns } from "./UserBulkLoadStatus.vue?vue&type=template&id=91b8f560&scoped=true&"
import script from "./UserBulkLoadStatus.vue?vue&type=script&lang=js&"
export * from "./UserBulkLoadStatus.vue?vue&type=script&lang=js&"
import style0 from "./UserBulkLoadStatus.vue?vue&type=style&index=0&id=91b8f560&scoped=true&lang=css&"
import style1 from "./UserBulkLoadStatus.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b8f560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b8f560')) {
      api.createRecord('91b8f560', component.options)
    } else {
      api.reload('91b8f560', component.options)
    }
    module.hot.accept("./UserBulkLoadStatus.vue?vue&type=template&id=91b8f560&scoped=true&", function () {
      api.rerender('91b8f560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuperAdmin/UserBulkLoadStatus.vue"
export default component.exports